<template>
  <!-- display:contents — layout-transparent, so slotted override content
       participates directly in the marker's flex context. -->
  <div class="icon-list-item-scope">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide, toRef } from 'vue'
import { useComponentScopedVariables } from '@render/composables/useComponentScopedVariables'
import { IconListItemProgressKey, type IconListItemState } from './progressContext'

// One instance wraps a single list item's slotted icon override. provide()
// runs in setup, so per-item context can only be established by a component
// boundary like this — a v-for in the parent template can't call provide().
const props = defineProps<{
  progress: number
  state: IconListItemState
}>()

provide(IconListItemProgressKey, {
  progress: toRef(props, 'progress'),
  state: toRef(props, 'state'),
})

// Nearest-provider semantics give each item its own scope, so a TipTap inside
// the slotted content reads this item's value via {{comp.progress}} etc.
useComponentScopedVariables('IconList', () => ({
  progress: props.progress,
  percent: Math.round(props.progress),
  state: props.state,
}))
</script>

<style scoped>
.icon-list-item-scope {
  display: contents;
}
</style>
